import React from 'react'
import { useWorkoutsContext } from '../hooks/useWorkoutsContext'

// Date Fns
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import { useAuthContext } from '../hooks/useAuthContext'

const WorkoutsDetails = ({workout}) => {

  const {dispatch} = useWorkoutsContext();
  const {user} = useAuthContext()
  const handleClick = async()=>{

    if(!user){
      return 
    }

    const response = await fetch('https://workoutbuddy-nt3r.onrender.com/api/workouts/' + workout._id,{
      method: 'DELETE',
      headers: {
        'Authorization' : `Bearer ${user.token}`
      }
    })
    const json = await response.json()

    if(response.ok){
      dispatch({type: 'DELETE_WORKOUT', payload: json})
    }
  }
  return (
    <div className='workout-details'>
        <h4>{workout.title}</h4>
        <p><strong>Load (in Kgs)</strong>{workout.load}</p>
        <p><strong>Reps: (in Kgs)</strong>{workout.reps}</p>
        <p>{formatDistanceToNow(new Date(workout.createdAt), {addSuffix: true})}</p>
        <span className="material-symbols-outlined" onClick={handleClick}>delete</span>
        
    </div>
  )
}

export default WorkoutsDetails